import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import Rectangle73 from "assets/images/pricing/Rectangle73New.png";
import Check from "assets/images/pricing/Check.png";
import { Container } from "@mui/material";
import Header from "../components/header";
import Footer from "../components/footer.js";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Helmet } from "react-helmet-async";
const InsightContent = () => {
     const navigate = useNavigate();

  const data = [
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
    { name: "Branded Hotspot", check1: Check, check2: Check, check3: Check },
  ];

  const Content = [
    {
      heading: "1. Claim and optimize your Google Business Profile",
      description:
        "Your Google profile is often the first thing potential customers see when searching for places to eat. Make sure your hours, photos, location, and menu are up to date. Encourage customers to leave reviews, and respond to them professionally. Local SEO still drives foot traffic, especially from mobile searches like “restaurants near me.”",
    },
    {
      heading: "2. Run location-based ads on Google and social media",
      description:
        "Targeted ads on Google, Instagram, and Facebook can bring in new customers nearby. Use radius-based targeting around your restaurant to promote time-sensitive offers, new dishes, or happy hour specials. Keep the creative simple, visual, and focused on one message.",
    },
    {
      heading: "3. Collect and use customer reviews",
      description:
        "Reviews are one of the most powerful marketing assets you have. They influence buying decisions and help your restaurant rank better online. Use a tool like TavloAI to request reviews after a visit, respond quickly, and track feedback trends.",
    },
    {
      heading: "4. Build a strong presence on Instagram and TikTok",
      description:
        "Visual platforms remain essential for restaurants. Share behind-the-scenes content, menu spotlights, staff highlights, and customer experiences. Reels and short-form videos continue to get strong engagement. If you have photogenic food or a unique atmosphere, lean into that on social media.",
    },

    {
      heading: "5. Offer loyalty rewards that actually matter",
      description:
        "Digital loyalty programs still work—but only if they’re easy to join and offer real value. Whether it’s a free drink after five visits or a discount on a customer’s birthday, make rewards feel personal. Use email or SMS to send reminders and offers based on visit history.",
    },

    {
      heading: "6. Use email and SMS marketing wisely",
      description:
        "Your customer list is one of your most valuable assets. Use it to send out weekly specials, holiday hours, or limited-time offers. Keep the content short and useful, with a clear call to action. SMS is especially effective for reminders and flash promotions.",
    },

    {
      heading: "7. Partner with local influencers and creators",
      description:
        "Micro-influencers with 5,000 to 50,000 followers often have more engaged audiences than big accounts. Invite them in for a tasting or exclusive event in exchange for posts. Focus on creators in your area who align with your brand—especially food bloggers or lifestyle content creators.",
    },
    {
      heading: "8. Host events or limited-time promotions",
      description:
        "People love a reason to visit beyond just the food. Consider wine pairing nights, chef’s specials, weekend brunches, or trivia nights. Promote these through all your channels. These types of events create buzz and can help fill slow nights.",
    },
    {
      heading: "9. Make your menu work harder online",
      description:
        "Your online menu shouldn’t just be a PDF. It should be mobile-friendly, optimized for keywords, and updated regularly. Add photos and short descriptions for popular items. Make sure it’s visible on your website, Google profile, and delivery platforms.",
    },

    {
      heading: "10. Monitor your performance and adjust",
      description:
        "Data is your best friend in 2025. Track which campaigns bring in the most traffic, which days perform best, and which reviews mention your top dishes. Use tools like Google Analytics, reservation platforms, or review analytics to guide your decisions instead of relying on guesswork.",
    },

    {
      heading: "Final thoughts",
      description:
        "While the tools may evolve, the foundation of great restaurant marketing stays the same: show up where your customers are, offer real value, and build trust through consistent experiences and communication.",
    },
  ];

  const [showButton, setShowButton] = React.useState(false);
  const [bottomOffset, setBottomOffset] = React.useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title> 10 AI Restaurant Marketing Strategies in 2025</title>
        <meta
          name="description"
          content="  Discover 10 proven Tavlo AI-powered restaurant marketing strategies for 2025 to boost reviews, attract customers, and grow your business."
        />
        <meta name="keywords" content="Restaurant Marketing" />
      </Helmet>
      <Header></Header>

      <MDBox
        sx={{
          py: 3,
          mt: { xs: 4, sm: 4, md: 16 },
          mb: 4,
          zIndex: 1,
          backgroundColor: "#fff",
          position: "relative",
        }}
      >
        <MDBox
          sx={{
            position: "absolute",
            top: {
              xs: 20,
              xm: 25,
              md: 10,
            },
            left: {
              xs: 10,
              xm: 25,
              md: 50,
            },
            fontSize: {
              xs: "20px",
              xm: "40px",
              md: "40px",
            },
            color: "gray",
          }}
        >
          <MDBox
            onClick={() => navigate(-1)}
            style={{ textDecoration: "none" }}
          >
            <KeyboardBackspaceIcon sx={{ color: "gray", fontSize: "40px" }} />
          </MDBox>
        </MDBox>

        <Container
          sx={{
            "@media (min-width:1580px)": { maxWidth: "1600px!important" },
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              alignItems: "center",
              width: { xs: "100%", sm: "90%", md: "90%" },
              margin: "auto",
            }}
          >
            {/* Left Side: Heading + Description */}
            <Grid
              item
              xs={6}
              md={5}
              sx={{
                mt: {
                  xs: 5,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox
                sx={{
                  width: {
                    xs: "100%",
                    sm: "90%",
                  },
                  pl: {
                    xs: 1,
                    sm: 1,
                    md: -2,
                  },

                  textAlign: "start",
                }}
              >
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      xs: "11px",
                      md: "14px",
                      color: "#F47C00",
                      letterSpacing: 0.7,
                      fontFamily: "Poppins",
                    },
                  }}
                >
                  Restaurant Marketing
                </MDTypography>
                <MDTypography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: {
                      xs: "15px",
                      md: "38px",
                    },
                    fontFamily: "Poppins",
                    color: "#318BEC",
                  }}
                >
                  10 AI Restaurant Marketing Strategies in 2025
                </MDTypography>
                <MDTypography
                  variant="body1"
                  sx={{
                    mt: {
                      xs: 1,
                      md: 2,
                    },
                    fontSize: {
                      xs: "7px",
                      md: "14px",
                    },
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    color: "#000",
                  }}
                >
                  24th July, 2025
                </MDTypography>
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={6}
              md={7}
              sx={{
                mt: {
                  xs: 4,
                  sm: 0,
                  md: 0,
                },
              }}
            >
              <MDBox sx={{ pl: "5%", pb: "4%" }}>
                <MDBox
                  component="img"
                  src={Rectangle73}
                  alt="AI dashboard"
                  sx={{
                    display: "block",
                    mx: "auto", // center image
                    width: {
                      xs: "215px",
                      sm: "320px",
                      md: "490px",
                      lg: "550px",
                      xl: "600px",
                    },
                    height: {
                      xs: "128px",
                      sm: "200px",
                      md: "240px",
                      lg: "300px",
                      xl: "340px",
                    },
                    borderRadius: {
                      xs: "5px",
                      sm: "16px",
                      md: "16px",
                    },
                    boxShadow: "3px 6px 20px 3px #00000066",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDBox
            sx={{
              width: {
                xs: "95%",
                sm: "90%",
                md: "90%",
              },
              margin: "auto",
            }}
          >
            <MDTypography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                color: "#000",
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              The marketing world moves fast, especially in the restaurant
              industry. New apps, social trends, and tech tools seem to appear
              every month. But while it's tempting to chase the latest viral
              hack, many restaurant owners forget that proven strategies still
              deliver results—even in 2025.
            </MDTypography>

            <MDTypography
              variant="body1"
              sx={{
                my: 2,
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                color: "#000",
                textAlign: "justify",
              }}
            >
              Here are ten restaurant marketing tactics that continue to work
              and should remain part of your playbook this year and beyond.
            </MDTypography>

            <MDBox
              sx={{
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
              }}
            >
              {Content.map((item, index) => (
                <MDBox key={index} mb={2}>
                  <MDTypography
                    variant="h6"
                    sx={{
                      color: "#000",
                      fontWeight: 900,
                      fontFamily: "Poppins",
                      mb: {
                        xs: 0.4,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      },
                      fontFamily: "Poppins",
                    }}
                  >
                    {item.heading}
                  </MDTypography>
                  <MDTypography
                    variant="body2"
                    sx={{
                      color: "#000",
                      fontFamily: "Poppins",
                      mb: {
                        xs: 1,
                        sm: 3,
                        md: 3,
                      },
                      fontSize: {
                        xs: "10.5px",
                        sm: "14px",
                        md: "1rem",
                      },
                      fontFamily: "Poppins",
                      textAlign: "justify",
                    }}
                  >
                    {item.description}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 1,
                  sm: 2,
                  md: 2,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              Start with what works. Then improve it with new tools, automation,
              and smart insights.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: {
                  xs: 2,
                  sm: 3,
                  md: 5,
                },
                fontSize: {
                  xs: "10.5px",
                  sm: "14px",
                  md: "1rem",
                },
                fontFamily: "Poppins",
                textAlign: "justify",
              }}
            >
              If you’re ready to save time and make smarter marketing decisions,
              try TavloAI. It helps you manage your reviews, track customer
              feedback, and grow your online presence—without adding to your
              daily workload.
            </MDTypography>
            <MDTypography
              variant="body2"
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                mb: 1,
                fontWeight: 700,
                fontSize: "12px",
                fontFamily: "Poppins",
                textTransform: "uppercase",
              }}
            >
              Tags
            </MDTypography>

            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: {
                  xs: 0.4,
                  sm: 1,
                  md: 1,
                },
                width: "100%",
                mt: 2,
              }}
            >
              <MDBox
                sx={{
                  color: "#000",
                  backgroundColor: "#E6E6E6",
                  px: {
                    xs: "8px",
                    sm: "16px",
                    md: "18px",
                  },
                  py: "4px",
                  borderRadius: "4px",
                  fontSize: {
                    xs: "8px",
                    sm: "12px",
                    md: "12px",
                  },
                  fontWeight: 400,
                  fontFamily: "Poppins",
                  textTransform: "none",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    background: "#E6E6E6",
                  },
                }}
              >
                Restaurant Marketing
              </MDBox>

              <MDBox
                sx={{
                  color: "#000",
                  backgroundColor: "#E6E6E6",
                  px: {
                    xs: "8px",
                    sm: "16px",
                    md: "18px",
                  },
                  py: "4px",
                  borderRadius: "4px",
                  fontSize: {
                    xs: "8px",
                    sm: "12px",
                    md: "12px",
                  },
                  fontWeight: 400,
                  fontFamily: "Poppins",
                  textTransform: "none",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    background: "#E6E6E6",
                  },
                }}
              >
                Restaurant Marketing
              </MDBox>
              <MDBox
                sx={{
                  color: "#000",
                  backgroundColor: "#E6E6E6",
                  px: {
                    xs: "8px",
                    sm: "16px",
                    md: "18px",
                  },
                  py: "4px",
                  borderRadius: "4px",
                  fontSize: {
                    xs: "8px",
                    sm: "12px",
                    md: "12px",
                  },
                  fontWeight: 400,
                  fontFamily: "Poppins",
                  textTransform: "none",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    background: "#E6E6E6",
                  },
                }}
              >
                Restaurant Marketing
              </MDBox>
            </MDBox>
          </MDBox>
        </Container>

        {showButton && (
          <MDBox
            sx={{
              position: "fixed",
              bottom: bottomOffset,
              right: { xs: 20, md: 35 },
              zIndex: 9999,
            }}
          >
            <MDBox
              onClick={scrollToTop}
              sx={{
                cursor: "pointer",
                p: { xs: 0.5, md: 1 },
                backgroundColor: "#F47C00",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "30px",
              }}
            >
              <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer></Footer>
    </MDBox>
  );
};

export default InsightContent;
